import { createEventerFn } from './eventer';

import { isDevEnv } from '../utils/common.utils';

export const entitiesRefreshed = createEventerFn(new EventTarget(), 'entitiesRefreshed', {
  log: true,
  isDev: isDevEnv,
})();
